import React, { useState, useEffect } from 'react'
import MainLayout from 'layouts/main'
import { useFlagcardContext } from 'app/contexts/flagcard'
import { getCountryPerceptions } from '../../../services/http/backoffice/country-perception/endpoints'
import backofficeDefinitionService from 'services/http/backoffice/definition/'

import { CreateYoutubeResponse } from './../../../services/http/backoffice/definition/types'

import Page from '@zera-admin/page'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import { Column, Row, PageHeader } from '@zera-admin/page'
import Button from '@zera-admin/button'
import Checkbox from '@zera-admin/checkbox'
import Input from '@zera-admin/input'
import DateTimePicker from '@zera-admin/datetime-picker'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { RadioGroup } from '@zera-admin/radio'
import Icon from '@zera-admin/icon'
import Form, {
  useForm,
  FormHookSubmitProps,
  FormHeader,
  FormFooter,
  FormSection,
} from '@zera-admin/form'
import { DateTimePickerHours } from 'app/shared/enums'
const Youtube = () => {
  const hoursArray: string[] = []
  for (const key in DateTimePickerHours) {
    if (typeof DateTimePickerHours[key] === 'string') {
      hoursArray.push(DateTimePickerHours[key])
    }
  }

  const [formValues, setFormValues] = useState<{
    countryPerceptions: Array<SelectOptionProps>
  }>({
    countryPerceptions: [],
  })
  const [flagcard] = useFlagcardContext()
  const [blackListWord, setBlackListWord] = useState<string>('')
  useEffect(() => {
    getCountryPerceptions()
      .then((res) => res.data.data)
      .then((res) =>
        setFormValues((state) => ({
          ...state,
          countryPerceptions: res.map((country: any) => {
            return { label: country?.description, value: country?.key }
          }),
        }))
      )
  }, [])

  const initialValues: CreateYoutubeResponse = {
    crawlingType: 'fetch',
    definitionType: '',
    definitionValue: '',
    countryPerception: 1,
    allowedLanguages: undefined,
    allowedDbs: undefined,
    useIncomingDefinition: false,
    environment: 'Alice',
    definitionBlackLists: undefined,
    periodicFetch: false,
    period: undefined,
    fetchComments: undefined,
    expireDayCountCommentTask: undefined,
    startAt: undefined,
    endAt: undefined,
    regionCode: undefined,
    pageLimit: undefined,
    fetchAllLanguages: true,
    language: undefined,
  }

  const form = useForm<CreateYoutubeResponse>({
    initialValues,
    onSubmit: (props) => handlerSubmit(props),
  })

  const handlerSubmit = (props: FormHookSubmitProps<CreateYoutubeResponse>) => {
    console.log(form.values)
    if (!props.errors) {
      if (form.values) {
        backofficeDefinitionService
          .createYoutube(form.values)
          .then(() => {
            flagcard.add({
              appearance: 'success',
              title: 'Kayıt işlemi başarılı',
              children:
                'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
            })
            form.handleBatchUpdate(initialValues)
          })
          .catch((error) => {
            console.log(error)
            flagcard.add({
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
      }
    }
  }

  const handleAddBlackListWord = () => {
    if (blackListWord) {
      form.handleFieldChange('definitionBlackLists', [
        ...(form.values.definitionBlackLists || []),
        blackListWord,
      ])
      setBlackListWord('')
    }
  }

  const handleRemoveBlackListWord = (index: number) => {
    form.handleFieldChange(
      'definitionBlackLists',
      form.values.definitionBlackLists?.filter((_, i) => i !== index)
    )
  }

  const renderPageContent = () => {
    return (
      <React.Fragment>
        <Form onSubmit={handlerSubmit}>
          <FormHeader
            title="Youtube Tanımlama Formu"
            description={
              <div style={{ marginBottom: '1.5rem' }}>
                <p>Form üzerinden aşağıdaki genel bilgileri doldurunuz.</p>
                <p style={{ margin: '0', color: '#A73121' }}>
                  Doldurulması zorunlu alanlar (*) işareti ile belirtilmiştir.
                </p>
              </div>
            }
          />
          <FormSection>
            <Row>
              <Column md={{ size: 3 }}>
                <RadioGroup
                  label="*CrawlingType"
                  name="crawlingType"
                  isRequired
                  options={[{ label: 'Fetch', value: 'fetch' }]}
                  value={form.values.crawlingType}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'crawlingType',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column md={{ size: 3 }}>
                <RadioGroup
                  label="*Definition Type"
                  name="definitionType"
                  isRequired
                  options={[
                    { label: 'Keyword', value: 'keyword' },
                    { label: 'Account', value: 'account' },
                    { label: 'Search', value: 'search' },
                    { label: 'Caption', value: 'caption' },
                  ]}
                  value={form.values.definitionType}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'definitionType',
                      e.currentTarget.value
                    )
                  }}
                />
              </Column>
            </Row>
            {form.values.definitionType === 'keyword' ? (
              <Row>
                <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                  <Input
                    type="url"
                    label="*Definition Value"
                    name="definitionValue"
                    isRequired
                    placeholder="Takip edilecek url giriniz."
                    value={form.values.definitionValue}
                    onChange={(e) => {
                      form.handleFieldChange(
                        'definitionValue',
                        e.currentTarget.value
                      )
                    }}
                  />
                </Column>
              </Row>
            ) : (
              <Row>
                <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                  <Input
                    type="url"
                    label="*Definition Value"
                    name="definitionValue"
                    isRequired
                    placeholder={
                      form.values.definitionType === 'caption'
                        ? 'Video ID giriniz'
                        : 'Definition value giriniz'
                    }
                    value={form.values.definitionValue}
                    onChange={(e) => {
                      form.handleFieldChange(
                        'definitionValue',
                        e.currentTarget.value
                      )
                    }}
                  />
                </Column>
              </Row>
            )}

            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Algı Seçiniz"
                  name="countryPerception"
                  options={formValues.countryPerceptions}
                  placeholder="Seçim yapın"
                  defaultValue={
                    formValues.countryPerceptions.find(
                      (country) => country.label === 'Türkiye'
                    ) || { label: 'Türkiye', value: 1 }
                  }
                  value={formValues.countryPerceptions.find(
                    (country) => country.value === form.values.countryPerception
                  )}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'countryPerception',
                      (e as SelectOptionProps).value
                    )
                  }}
                />
              </Column>
            </Row>

            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Database Seçimi"
                  name="allowedDbs"
                  description="*Çekilen verilerin işlendikten sonra hangi db 'lere kaydedileceğini belirtir."
                  placeholder="Seçim Yapın"
                  isMultiple
                  options={[{ label: 'Oracle', value: 'oracle' }]}
                  value={form.values.allowedDbs?.map((db) => ({
                    label: db,
                    value: db,
                  }))}
                  onChange={(e) => {
                    const value = e as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'allowedDbs',
                      value.length > 0 ? value.map((db) => db.value) : undefined
                    )
                  }}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  label="Bu definitiondan gelen postlar direkt olarak bu definition ile işaretlensin mi işaretlenmesin mi?"
                  name="useIncomingDefinition"
                  isChecked={form.values.useIncomingDefinition}
                  onChange={(e) => {
                    form.handleFieldChange(
                      'useIncomingDefinition',
                      e.currentTarget.checked
                    )
                  }}
                />
              </Column>
            </Row>

            <>
              <Row>
                <Column xs={{ size: 4 }}>
                  <Input
                    name="blackListWord"
                    label="Tanımlama Kara Listesi"
                    placeholder="Bir kara liste kelimesi giriniz"
                    description="Bir kara liste kelimesi giriniz"
                    value={blackListWord}
                    onChange={(props) => {
                      setBlackListWord(props.currentTarget.value)
                    }}
                  />
                </Column>
                <Column xs={{ size: 4 }}>
                  <Button
                    onClick={handleAddBlackListWord}
                    appearance="primary"
                    children="Ekle"
                    style={{ marginTop: '16px' }}
                  />
                </Column>
              </Row>
              {form.values.definitionBlackLists?.map((word, index) => (
                <Row key={index}>
                  <Column xs={{ size: 4 }}>{word}</Column>
                  <Column>
                    <Button
                      onClick={() => handleRemoveBlackListWord(index)}
                      appearance="error"
                      children="Kaldır"
                      style={{ marginTop: '16px' }}
                    />
                  </Column>
                </Row>
              ))}
            </>

            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  label="Periyodik olarak çekilsin mi ?"
                  name="periodicFetch"
                  isChecked={form.values.periodicFetch}
                  onChange={(e) => {
                    const value = e.currentTarget.checked
                    form.handleFieldChange('periodicFetch', value)
                  }}
                />
              </Column>
            </Row>
            {form.values.periodicFetch && (
              <Row>
                <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                  <Input
                    label="*Period"
                    name="period"
                    placeholder="Periyot giriniz (0 * * * *)"
                    description="Geçerli bir periyot giriniz"
                    isRequired={form.values.periodicFetch}
                    value={form.values.period}
                    onChange={(e) => {
                      const value = e.currentTarget.value
                      form.handleFieldChange(
                        'period',
                        value !== '' ? value : undefined
                      )
                    }}
                  />
                </Column>
              </Row>
            )}
            {form.values.definitionType === 'account' && (
              <Row>
                <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                  <Checkbox
                    label="Kanalın yorumları da çekilsin mi?"
                    name="fetchComments"
                    isChecked={form.values.fetchComments}
                    onChange={(e) => {
                      const value = e.currentTarget.checked
                      form.handleFieldChange('fetchComments', value)
                    }}
                  />
                </Column>
              </Row>
            )}

            {form.values.definitionType === 'account' &&
              form.values.fetchComments === true && (
                <Row>
                  <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                    <Input
                      label="Kanalın yorumları çekilecek ise kaç gün öncesine kadarki yorumları çekilecek"
                      name="expireDayCountCommentTask"
                      placeholder="gün sayısı giriniz"
                      type="number"
                      description="Geçerli bir sayı giriniz"
                      isRequired={form.values.fetchComments}
                      value={form.values.expireDayCountCommentTask}
                      onChange={(e) => {
                        const value = e.currentTarget.value
                        form.handleFieldChange(
                          'expireDayCountCommentTask',
                          e.currentTarget.value !== null ? value : undefined
                        )
                      }}
                    />
                  </Column>
                </Row>
              )}
            {form.values.definitionType === 'search' && (
              <>
                <Row>
                  <Column xs={{ size: 12 }} md={{ size: 8 }}>
                    <DateTimePicker
                      times={hoursArray}
                      label="Başlangıç Tarihi Seçin"
                      description="*Belirtilen tarihten sonraki veriler çekilir."
                      placeholder="Seçim Yapın"
                      name="startAt"
                      type="default"
                      value={form.values.startAt?.toString()}
                      onChange={(e) => {
                        e
                          ? form.handleFieldChange(
                              'startAt',
                              new Date(e).toISOString()
                            )
                          : form.handleFieldChange('startAt', undefined)
                      }}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column xs={{ size: 12 }} md={{ size: 8 }}>
                    <DateTimePicker
                      times={hoursArray}
                      label="Bitiş Tarihi Seçin"
                      description="*Belirtilen tarihten önceki veriler çekilir."
                      placeholder="Seçim Yapın"
                      name="endAt"
                      type="default"
                      value={form.values.endAt?.toString()}
                      onChange={(e) => {
                        e
                          ? form.handleFieldChange(
                              'endAt',
                              new Date(e).toISOString()
                            )
                          : form.handleFieldChange('endAt', undefined)
                      }}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                    <Input
                      label="*Region Code"
                      name="regionCode"
                      placeholder="Bölge kodu giriniz"
                      description="Geçerli bir bölge kodu giriniz"
                      value={form.values.regionCode}
                      onChange={(e) => {
                        const value = e.currentTarget.value
                        form.handleFieldChange(
                          'regionCode',
                          value !== '' ? value : undefined
                        )
                      }}
                    />
                  </Column>
                </Row>
                <Row>
                  <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                    <Input
                      min={0}
                      label="*Page Limit"
                      name="pageLimit"
                      type="number"
                      placeholder="Sayfa limiti giriniz"
                      description="Geçerli bir sayfa limiti giriniz(0 girilirse limit yoktur)"
                      value={form.values.pageLimit}
                      onChange={(e) => {
                        const value = e.currentTarget.value
                        form.handleFieldChange(
                          'pageLimit',
                          e.currentTarget.value !== null ? value : undefined
                        )
                      }}
                    />
                  </Column>
                </Row>
              </>
            )}
            {form.values.definitionType === 'caption' && (
              <>
                <Row>
                  <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                    <Checkbox
                      label="Tüm dillerdeki captionlar çekilsin mi?"
                      name="fetchAllLanguages"
                      isChecked={form.values.fetchAllLanguages}
                      onChange={(e) => {
                        const value = e.currentTarget.checked
                        form.handleFieldChange('fetchAllLanguages', value)
                      }}
                    />
                  </Column>
                </Row>
                {form.values.fetchAllLanguages === false && (
                  <Row>
                    <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                      <Input
                        label="*Language"
                        name="language"
                        placeholder="Dil giriniz"
                        description="Geçerli bir dil giriniz"
                        value={form.values.language}
                        onChange={(e) => {
                          const value = e.currentTarget.value
                          form.handleFieldChange(
                            'language',
                            value !== '' ? value : undefined
                          )
                        }}
                      />
                    </Column>
                  </Row>
                )}
              </>
            )}
          </FormSection>
          <FormFooter align="start">
            <Button
              appearance="primary"
              iconBefore={<Icon name="add-item" />}
              children="Tanımlama Oluştur"
              isDisabled={
                form.values.crawlingType !== '' &&
                form.values.definitionType !== '' &&
                form.values.definitionValue !== ''
                  ? false
                  : true
              }
              type="submit"
            />
          </FormFooter>
        </Form>
      </React.Fragment>
    )
  }

  return (
    <MainLayout>
      <Page>
        <PageHeader
          breadcrumbs={
            <Breadcrumb>
              <BreadcrumbItem text="Anasayfa" href="/" />
              <BreadcrumbItem text="Tanımlama" href="/definition" />
              <BreadcrumbItem
                text="Tanımlama oluştur"
                href="/definition/create"
              />
              <BreadcrumbItem text="Youtube" />
            </Breadcrumb>
          }
        />

        {renderPageContent()}
      </Page>
    </MainLayout>
  )
}

export default Youtube
